var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contain"},[_c('Header',{attrs:{"config":_vm.config}}),_c('div',{staticClass:"main-container"},[_c('sidebar'),_c('div',{staticClass:"main-content"},[_c('div',{staticClass:"main-page"},[_c('div',{staticClass:"channel-container"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.about.content)}})])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }